import { SearchOutlined } from '@mui/icons-material';
import Close from '@mui/icons-material/Close';
import {Alert, Button,Container,Grid,IconButton,InputAdornment, LinearProgress,Skeleton, styled,TextField,Typography} from '@mui/material';
import Localization from 'l18n/l18n';
import debouce from 'lodash.debounce';
import React, { useCallback,useEffect, useState} from 'react';
import {Helmet} from 'react-helmet';
import InfiniteScroll from 'react-infinite-scroll-component';
import PatientsModel from '../../models/patients';
import Popup from './add_new_patient';
import PatientCard from './components/patient_card';

export default function Patients() {
 
const [openPopup , setOpenPopup] = useState(false);
const [patients, setPatients] =  useState([]);
const [pageNumber, setPageNumber] = useState(1);
const [hasMore, setHasMore] = useState(true);
const [error, setError] = useState(false);
const [loading, setLoading] = useState(true);
const [emptyResponse, setEmptyResponse] = useState(false);
const [searchValue,setSearchValue] = useState('');
const StyledButton = styled(Button)({
 
  backgroundColor:'#279BFF',
  color:'#ffffff',
  fontSize:'1rem',
  minWidth:'10rem',
  borderRadius:0,
  height:'100%',
  boxShadow:'none',
});

const StyledTextField = styled(TextField)({
  border:'0 !important',
  borderRadius:0,
  background:'#eeeeee',
  width:'100%',
  '& .MuiOutlinedInput-root' : {
    '& fieldset': {            // - The <fieldset> inside the Input-root
      border:0 // - Set the Input border
    },
   
  }
});

const getSearchResults = useCallback(
  debouce(value => {
    getData(value);
  }, 1200),
  []
);

useEffect(() => {
  setPageNumber(1);
  getSearchResults(searchValue);
}, [searchValue]);

 

const getData = useCallback(async (search=false) => {
 
  setError(false) ;  setEmptyResponse(false) ; setLoading(true) ;

  PatientsModel.getPatients({page: pageNumber,search })
    .then(async (response) => {
      setPageNumber((prev) => prev+1 );
      const PatientsData = response.patients_list || [];

      if (PatientsData.length < 1 ) {
        setHasMore(false);
      }
      if(PatientsData.length < 1 && patients.length <1 ) {
        setEmptyResponse(true);
      }
      setPatients(patients.concat(PatientsData) );
      setLoading(false);
      return;
    })
    .catch((err) =>{ setHasMore(false); setLoading(false); setError(true); });
}, [pageNumber, patients]);

 

const errorMessage = !loading && error ? <Grid item xs={12}> <Alert severity="error">{Localization.translate['error']}</Alert> </Grid> :'';
const emptyMessage = !loading && emptyResponse ?  <Grid item xs={12}> <Alert severity="warning">{Localization.translate['empty_patients_alert']}</Alert> </Grid> : '';

const loadingSkelton =loading ? Array.from(Array(8)).map((i,key)=>
(<Grid  item lg={3} key={key} md={4} xs={12} sx={{position:'relative'}}>
  <div style={{position:'relative',height:80,width:'100%',display:'grid',justifyItems:'center'}}>
  <Skeleton variant="circular" width={80} animation="wave"  height={80}  sx={{border: '6px solid #FFFFFF',zIndex:2, width: 80,top:'2.5rem', height: 80  }} />
  </div>
  <Skeleton variant="rectangular" width={'100%'} height={220} sx={{borderTopLeftRadius:10,borderTopRightRadius:10}}/ >
  <Skeleton variant="rectangular" animation="wave" sx={{borderBottomLeftRadius:10,borderBottomRightRadius:10}} width={'100%'} height={40} />
</Grid> )) : '';


return (
  <>
    <Helmet>
        <title>{`${Localization.translate['app_name']} | ${Localization.translate['patients']}`}</title>
    </Helmet>
    <Container maxWidth="lg" sx={{ mt: 4, mb: 4,ml:{xs:0,md:2,lg:10}}}>
        <Grid container spacing={4}>
          <Grid item xs={12} md={10}  >
          <Typography component="h4" variant="h4" color="#000000"  > {Localization.translate['patients']} </Typography>
       
          </Grid>
          <Grid item xs={12} lg={6} container>
            <Grid item  xs={12} md={10} >
            <StyledTextField value={searchValue} onChange={(e)=>setSearchValue(e.target.value)} autoFocus={true}  placeholder={Localization.translate['patient_search_by_phone_or_name']}  InputProps={{
            startAdornment: (
              <InputAdornment position="start">
              <SearchOutlined />
            </InputAdornment>
          ),
          endAdornment:(
            <InputAdornment position="end">
            <IconButton
              aria-label="toggle password visibility"
              onClick={()=>setSearchValue('')}
              edge="end"
              >
              {searchValue.trim().length > 0? <Close /> : ''}
            </IconButton>
          </InputAdornment>
          )
        }}/>
            </Grid>
            <Grid item xs={12} md={2}>
            <StyledButton variant="contained" >{Localization.translate['search']}</StyledButton>
            </Grid>
          </Grid>
          {/*
              Add patient button
          {<Grid item xs={12} md={2}>
          <Button variant='contained' sx={{color:'#FFFFFF',boxShadow:'none',borderRadius:0 }} onClick={()=>setOpenPopup(true)}>{Localization.translate['add_patient']}</Button>
        </Grid>} */}

        <Grid item container spacing={2}>
   
        <Grid container>
        {errorMessage}
          {emptyMessage}
          <Grid item xs={12}>
            <Typography sx={{ mt: 2, ml:1, fontWeight:'bold' }}>  {Localization.translate['latest_added']} : </Typography>
          </Grid>
        <Grid item xs={12}>
          <InfiniteScroll
            style={{display: 'flex',width:'100%'}}   next={() => getData()} hasMore={hasMore} dataLength={patients.length} loader={<LinearProgress />} >
             <Grid item xs={12} alignItems="stretch"  container spacing={8} sx={{mt: 4}}>
              {patients.map((patientInformation,key) =>  <PatientCard key={key}  {...patientInformation}/>  )}
            </Grid>
          </InfiniteScroll>
           <Grid item xs={12} alignItems="stretch"  container spacing={8} sx={{mt: 4}}>
           {loadingSkelton}
            </Grid>
          </Grid>
        </Grid>
          <Popup  openPopup = {openPopup}  setOpenPopup = {setOpenPopup} />
        </Grid>
         </Grid>
    </Container> 
              </>
    );  }